import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import '../../scrollbar.css';
import { useStateValue } from '../../ContextApi/StateProvider';

function SideMenu() {
  const history = useHistory();
  const location = useLocation();
  const [{ user }, dispatch] = useStateValue();
  const [showSideMenu, setSideMenu] = useState(false);
  const getNameInitials = (name) => {
    if (!name) return '';
    let initials = name.match(/\b\w/g) || [];
    initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
    return initials;
  };

  return (
    <div>
      <div
        className="fixed block sm:hidden z-60 p-2 bg-white w-full h-10 border"
        onClick={() => setSideMenu((prev) => !prev)}
      >
        <img src="assets/img/sideMenu.png" className="w-6 h-6" />
        {/* <img
          src="assets/img/Close.svg"
          className="absolute top-3 right-3 h-3 cursor-pointer"
          alt=""
          onClick={() => setSideMenu((prev) => !prev)}
        /> */}
      </div>
      <div
        className={`fixed sideMenu ${showSideMenu ? 'block' : 'hidden'} md:block lg:flex flex-col h-full z-50`}
        style={{ width: showSideMenu ? '50%' : '14%' }}
      >
        <div className="w-full mt-4 mb-20 md:mb-0">
          <div
            className={`${
              location.pathname === '/dashboard' && 'text-activeIcon'
            } block md:flex items-center h-1/7 ml-4 mb-1 cursor-pointer`}
            onClick={() => history.push('/dashboard')}
          >
            {location.pathname === '/dashboard' ? (
              <div className="bg-btnBg flex w-full h-10 m-auto items-center relative side-bar">
                <img src="assets/img/Dashboard_White.svg" alt="" className="h-4 mx-2" />
                <p className="text-white text-sm hidden md:block">Dashboard</p>
                <img src="assets/img/leftArrow.svg" className="absolute right-4" style={{ height: '10px' }} alt="" />
              </div>
            ) : (
              <div className="flex w-full h-10 m-auto items-center side-bar">
                <img src="assets/img/DashbordIcon.svg" alt="" className="h-4 mx-2" />
                <p className="text-textBoldBlack text-sm hidden md:block">Dashboard</p>
              </div>
            )}
          </div>

          <div
            className={`${
              location.pathname === '/zone' && 'text-activeIcon'
            } block md:flex  items-center h-1/7 ml-4 mb-1 cursor-pointer`}
            onClick={() => history.push('/zone')}
          >
            {location.pathname === '/zone' ? (
              <div className="bg-btnBg flex w-full h-10 m-auto items-center relative side-bar">
                <img src="assets/img/Zones_Active.svg" alt="" className="h-4 mx-2" />
                <p className="text-white text-sm hidden md:block">Zones</p>
                <img src="assets/img/leftArrow.svg" className="absolute right-4" style={{ height: '10px' }} alt="" />
              </div>
            ) : (
              <div className="flex w-full h-10 m-auto items-center side-bar">
                <img src="assets/img/Zones_Inactive.svg" alt="" className="h-4 mx-2" />
                <p className="text-textBoldBlack text-sm hidden md:block">Zones</p>
              </div>
            )}
          </div>
          <div
            className={`${
              location.pathname === '/projects' && 'text-activeIcon'
            } block md:flex  items-center h-1/7 ml-4 mb-1 cursor-pointer`}
            onClick={() => history.push('/projects')}
            // style={{ paddingLeft: '0px' }}
          >
            {location.pathname === '/projects' ? (
              <div className="bg-btnBg flex w-full h-10 m-auto items-center relative side-bar">
                <img src="assets/img/Project_White.svg" alt="" className="h-4 mx-2" />
                <p className="text-white text-sm hidden md:block">Project</p>
                <img src="assets/img/leftArrow.svg" className="absolute right-4" style={{ height: '10px' }} alt="" />
              </div>
            ) : (
              <div className="flex w-full h-10 m-auto items-center side-bar">
                <img src="assets/img/ProjectIcon.svg" alt="" className="h-4 mx-2" />
                <p className="text-textBoldBlack text-sm hidden md:block">Project</p>
              </div>
            )}
          </div>

          <div
            className={`${
              location.pathname === '/users' && 'text-activeIcon'
            } block md:flex  items-center h-1/7 ml-4 mb-1 cursor-pointer`}
            onClick={() => history.push('/users')}
            // style={{ paddingLeft: '0px' }}
          >
            {location.pathname === '/users' ? (
              <div className="bg-btnBg flex w-full h-10 m-auto items-center relative side-bar">
                <img src="assets/img/User_White.svg" alt="" className="h-4 mx-2" />
                <p className="text-white text-sm hidden md:block">Users</p>
                <img src="assets/img/leftArrow.svg" className="absolute right-4" style={{ height: '10px' }} alt="" />
              </div>
            ) : (
              <div className="flex w-full h-10 m-auto items-center side-bar">
                <img src="assets/img/UserIcon.svg" alt="" className="h-4 mx-2" />
                <p className="text-textBoldBlack text-sm hidden md:block">Users</p>
              </div>
            )}
          </div>

          <div
            className={`${
              location.pathname === '/inventory' && 'text-activeIcon'
            } block md:flex h-1/7 items-center ml-4 mb-1 cursor-pointer`}
            onClick={() => history.push('/inventory')}
            // style={{ paddingLeft: '0px' }}
          >
            {location.pathname === '/inventory' ? (
              <div className="bg-btnBg flex w-full h-10 m-auto items-center relative side-bar">
                <img src="assets/img/Devices_White.svg" alt="" className="h-4 mx-2" />
                <p className="text-white text-sm hidden md:block">Devices</p>
                <img src="assets/img/leftArrow.svg" className="absolute right-4" style={{ height: '10px' }} alt="" />
              </div>
            ) : (
              <div className="flex w-full h-10 m-auto items-center side-bar">
                <img src="assets/img/DevicesIcon.svg" alt="" className="h-4 mx-2" />
                <p className="text-textBoldBlack text-sm hidden md:block">Devices</p>
              </div>
            )}
          </div>

          <div
            className={`${
              location.pathname === '/webhooks' && 'text-activeIcon'
            } block md:flex items-center h-1/7 ml-4 mb-1 cursor-pointer`}
            onClick={() => history.push('/webhooks')}
          >
            {location.pathname === '/webhooks' ? (
              <div className="bg-btnBg flex w-full h-10 m-auto items-center relative side-bar">
                <img src="assets/img/Webhook_White.svg" alt="" className="h-4 mx-2" />
                <p className="text-white text-sm hidden md:block">Webhooks</p>
                <img src="assets/img/leftArrow.svg" className="absolute right-4" style={{ height: '10px' }} alt="" />
              </div>
            ) : (
              <div className="flex w-full h-10 m-auto items-center side-bar">
                <img src="assets/img/WebhookIcon.svg" alt="" className="h-4 mx-2" />
                <p className="text-textBoldBlack text-sm hidden md:block">Webhooks</p>
              </div>
            )}
          </div>
          <div
            className={`${
              location.pathname === '/organization' && 'text-activeIcon'
            } block md:flex items-center h-1/7 ml-4 mb-1 cursor-pointer`}
            onClick={() => history.push('/organization')}
          >
            {location.pathname === '/organization' ? (
              <div className="bg-btnBg flex w-full h-10 m-auto items-center relative side-bar">
                <img src="assets/img/SettingsWhite.svg" alt="" className="h-4 mx-2" />
                <p className="text-white text-sm hidden md:block">Settings</p>
                <img src="assets/img/leftArrow.svg" className="absolute right-4" style={{ height: '10px' }} alt="" />
              </div>
            ) : (
              <div className="flex w-full h-10 m-auto items-center side-bar">
                <img src="assets/img/SettingsGrey.svg" alt="" className="h-4 mx-2" />
                <p className="text-textBoldBlack text-sm hidden md:block">Settings</p>
              </div>
            )}
          </div>
        </div>

        <div className="logout rounded-md">
          <div
            className={`mr-2 h-6 md:h-12 w-6 md:w-12 flex justify-center items-center rounded-full ${
              !user?.avatar && 'bg-primary'
            } userInfo cursor-pointer`}
            onClick={() => history.push('/account')}
          >
            {user?.avatar ? (
              <img src={`${user?.avatar}?${global.Date.now()}`} className="h-full w-full rounded-full" />
            ) : (
              <span className="text-base">{getNameInitials(user?.userName)}</span>
            )}
          </div>
          <div className="flex flex-col items-center w-full">
            <span className="text-sm hidden md:block cursor-pointer" onClick={() => history.push('/account')}>
              {user?.userName}
            </span>
            <button
              type="submit"
              className="logoutBtn font-bold px-0 md:px-6 py-0 md:py-2"
              onClick={() => {
                localStorage.clear();
                history.replace('/');
                dispatch({
                  type: 'USER_DATA',
                  user: null,
                });
              }}
            >
              Logout
            </button>
          </div>
        </div>
        {/* <div className="relative bottom-0 text-center text-xs">
        <img src="assets/img/icon1.svg" className="w-28 mx-auto mb-3" alt="" />
        <span className="mx-auto text-textBoldBlack">© 2021. All Rights Reserved</span>
      </div> */}
      </div>
    </div>
  );
}

export default SideMenu;
